<!-- 城市o2o -->
<template>
  <div class="warp">
    <div class="banner">
      <br />
      <p>绿茶城市O2O系统</p>
      <span>
        实现线上线下的深度链接
        <br />搭建属于您的新零售平台
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="city1">
      <div class="title">
        <span>绿茶城市O2O系统是什么？</span>
      </div>
      <p>绿茶城市O2O系统是一款线上-线下一体的O2O系统，涵盖外卖、团购、上门O2O服务、同城购物、餐饮酒店预订等综合性的本地生活服务O2O系统。支持二次开发，全平台互通。全方位覆盖美团式电商、京东到家模式、外卖订餐、上门O2O等模式，一套系统，全渠道管理！</p>
      <img src="../../assets/images/city02.jpg" />
    </div>
    <div class="city2">
      <div class="title">
        <span>多种模式 实现线上线下一体化运营</span>
      </div>
      <ul class="list2">
        <li>
          <div class="top">
            <img src="../../assets/images/city03.png" />
            <span>京东到家模式</span>
            <p>生鲜便利，闪电送达</p>
          </div>
          <div class="btm">
            <span>招商入驻</span>
            <span>配送服务</span>
            <span>LBS定位</span>
            <span>平台运营</span>
          </div>
        </li>
        <li>
          <div class="top">
            <img src="../../assets/images/city04.png" />
            <span>美团式电商</span>
            <p>搭建吃喝玩乐 一站式商城</p>
          </div>
          <div class="btm">
            <span>综合商圈</span>
            <span>团购促销</span>
            <span>分销管理</span>
            <span>种类齐全</span>
          </div>
        </li>
        <li>
          <div class="top">
            <img src="../../assets/images/city05.png" />
            <span>外卖订餐</span>
            <p>打造足不出户的完美体验</p>
          </div>
          <div class="btm">
            <span>LBS定位</span>
            <span>送货上门</span>
            <span>订单提醒</span>
            <span>评论晒单</span>
          </div>
        </li>
        <li>
          <div class="top">
            <img src="../../assets/images/city06.png" />
            <span>上门O2O</span>
            <p>行成上门+互联网的智慧模式</p>
          </div>
          <div class="btm">
            <span>周边服务</span>
            <span>服务预约</span>
            <span>支付尾款</span>
            <span>评论晒单</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="city3">
      <div class="title">
        <span>满足不同角色的使用习惯和操作需求</span>
        <p>
          绿茶充分考虑运营过程中不同角色的使用需求及体验，为您提供一整套
          城市O2O管理软件产品，方便您进行管理及运营
        </p>
      </div>
      <ul class="swiper-tab">
        <li @click="changeTab(1)" :class="indexActive==1?'indexActive':''">
          <span>消费者</span>
          <i></i>
        </li>
        <li @click="changeTab(2)" :class="indexActive==2?'indexActive':''">
          <span>门店商家</span>
          <i></i>
        </li>
        <li @click="changeTab(3)" :class="indexActive==3?'indexActive':''">
          <span>代理商</span>
          <i></i>
        </li>
        <li @click="changeTab(4)" :class="indexActive==4?'indexActive':''">
          <span>平台运营公司</span>
          <i></i>
        </li>
      </ul>

      <swiper :options="swipersocial" ref="mySwiper">
        <!-- slides -->
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/city07.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/city08.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/city09.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/city10.jpg" />
          </div>
        </swiper-slide>

        <!-- Optional controls ,显示小点-->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="city4">
      <div class="title">
        <span>城市O2O系统清晰的角色关系链</span>
        <p>
          城市O2O系统涵盖消费者、商家店铺、平台运营公司、驿站端、配送员等角色，
          各个角色分工分明、关系清晰，打造完整的线上线下交易闭环！
        </p>
      </div>
    </div>

    <div class="city5">
      <div class="title">
        <span>绿茶城市O2O系统能为你做什么？</span>
        <p>6大融合实现线上线下的深度链接，助您建立符合当下及未来发展的新零售！</p>
      </div>
      <ul>
        <li>
          <img src="../../assets/images/city12.jpg" />
          <span>会员通</span>
          <p>线上线下一套会员数据，支付即会员，积分卡券同享</p>
        </li>
        <li>
          <img src="../../assets/images/city13.jpg" />
          <span>商品通</span>
          <p>全平台统一进行商品、库存管理，线上线下同商品库存数据打通</p>
        </li>
        <li>
          <img src="../../assets/images/city14.jpg" />
          <span>营销通</span>
          <p>会员精细化管理，线上线下全渠道同步营销，丰富的营销功能，激活会员复购</p>
        </li>
        <li>
          <img src="../../assets/images/city15.jpg" />
          <span>服务通</span>
          <p>含同城配送系统，方便平台自建(类似达达/蜂鸟)同城配送团队，打通线上线下服务闭环</p>
        </li>
        <li>
          <img src="../../assets/images/city16.jpg" />
          <span>支付通</span>
          <p>支持微信/支付宝/银联等主流支付方式，线下对接收银台、小票打印机，两端数据同步</p>
        </li>
        <li>
          <img src="../../assets/images/city17.jpg" />
          <span>数据通</span>
          <p>线上线下用户消费大数据沉淀、融合，便于进行用户分析、营业分析、营销效果分析</p>
        </li>
      </ul>
    </div>

    <div class="city3 city6">
      <div class="title">
        <span>为什么选择绿茶城市O2O系统？</span>
      </div>
      <swiper :options="swipersub" style>
        <!-- slides -->
        <swiper-slide class="swiper-item">
          <div class="list6">
            <div class="t1">
              <span>雄厚资质</span>
              <b></b>
            </div>
            <div class="t2">
              <ul>
                <li><img src="../../assets/images/city18.png"><span>高新技术企业</span></li>
                <li><img src="../../assets/images/city19.png"><span>10年+经验开发团队</span></li>
                <li><img src="../../assets/images/city20.png"><span>20+项发明专利证书</span></li>
                <li><img src="../../assets/images/city21.png"><span>10年+互联网技术沉淀</span></li>
                <li><img src="../../assets/images/city22.png"><span>60+款创新知识产权</span></li>
                <li><img src="../../assets/images/city23.png"><span>其他更多荣誉资质</span></li>
              </ul>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="swiper-item">
          <div class="list6">
            <div class="t1">
              <span>产品优势</span>
              <b></b>
            </div>
            <div class="t2">
              <ul>
                <li><img src="../../assets/images/city24.png"><span>独家源码出售</span></li>
                <li><img src="../../assets/images/city25.png"><span>产品更新迅速</span></li>
                <li><img src="../../assets/images/city26.png"><span>产品原生开发</span></li>
                <li><img src="../../assets/images/city27.png"><span>专属定制开发</span></li>
                <li><img src="../../assets/images/city28.png"><span>方便二次开发</span></li>
                <li><img src="../../assets/images/city29.png"><span>全球20000+客户</span></li>
              </ul>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="swiper-item">
          <div class="list6">
            <div class="t1">
              <span>前瞻行业</span>
              <b></b>
            </div>
            <div class="t2">
              <ul>
                <li><img src="../../assets/images/city30.png"><span>设立战略研究院</span></li>
                <li><img src="../../assets/images/city31.png"><span>产品享誉全国</span></li>
                <li><img src="../../assets/images/city32.png"><span>开发搭建O2O系统</span></li>
                <li><img src="../../assets/images/city33.png"><span>产品更新迅速</span></li>
              </ul>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="swiper-item">
          <div class="list6">
            <div class="t1">
              <span>优质服务</span>
              <b></b>
            </div>
            <div class="t2">
              <ul>
                <li><img src="../../assets/images/city34.png"><span>强大的售后团队</span></li>
                <li><img src="../../assets/images/city35.png"><span>完美的技术支持</span></li>
                <li><img src="../../assets/images/city36.png"><span>迅速响应服务</span></li>
                <li><img src="../../assets/images/city37.png"><span>全方位服务</span></li>
                <li><img src="../../assets/images/city38.png"><span>平台搭建部署全程指导</span></li>
                <li><img src="../../assets/images/city39.png"><span>更多其他的服务</span></li>
              </ul>
            </div>
          </div>
        </swiper-slide>

        <!-- Optional controls ,显示小点-->
        <div class="swiper-pagination swiper-pagination1" slot="pagination"></div>
      </swiper>
    </div>

    <div class="city7">
      <h3>专业的<span>营销型城市O2O系统</span></h3>
      <h4>我们不断进步的脚步，是为了给您带来最好的服务</h4>
      <button type="button" @click="toService">微信客服</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "cityoto",

  data() {
    const vm = this;
    return {
      indexActive: 1,
      swipersocial: {
        // loop: true,
        speed: 500, //匀速时间
        pagination: {
          el: ".swiper-pagination",
        },
        on: {
          slideChangeTransitionEnd: function () {
            vm.indexActive = this.activeIndex + 1;
            // console.log(vm);
            // debugger;
          },
        },
      },

      swipersub: {
        // loop: true,
        speed: 500, //匀速时间
        pagination: {
          el: ".swiper-pagination1",
        },
      },
    };
  },
  mounted() {},

  methods: {
    toService(){
      window.location.href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9"
    },
    changeTab(i) {
      this.$nextTick(function () {
        this.$refs.mySwiper.swiper.slideTo(i - 1, 500, false);
        this.indexActive = i;
      });
    },
  },
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/city01.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #f05f58;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: 0.9rem;
      display: block;
    }
  }
  .title {
    padding: 0 0.3rem;
    span {
      font-size: 0.5rem;
      padding: 0.7rem 0;
      text-align: center;
      font-weight: 500;
      display: block;
    }
    p {
      font-size: 0.28rem;
      text-align: center;
      margin: -0.3rem 0 0.8rem;
      line-height: 0.5rem;
    }
  }
  .city1 {
    padding: 0.4rem 0;
    box-shadow: 0px 0px 1rem 0px rgba(70, 55, 123, 0.2);
    background-color: #fff;
    p {
      font-size: 0.34rem;
      line-height: 0.55rem;
      color: #666;
      padding: 0 0.3rem;
      text-indent: 2em;
    }
    img {
      width: 100%;
      margin: 0.3rem 0;
    }
  }
  .city2 {
    padding: 0.5rem 0;
    .list2 {
      display: flex;
      padding: 0.2rem;
      flex-wrap: wrap;
      li {
        width: 46%;
        border: 1px solid rgb(229, 229, 229);
        background-color: rgb(242, 243, 247);
        padding: 0.2rem;
        margin: 0 2%;
        text-align: center;
        margin-bottom: 0.5rem;
        .top {
          padding: 0.3rem 0;
          img {
            width: 1.2rem;
            height: 1.2rem;
          }
          span {
            font-size: 0.36rem;
            display: block;
            padding: 0.1rem 0;
          }
          p {
            font-size: 0.28rem;
            color: #666;
          }
        }
        .btm {
          display: flex;
          flex-wrap: wrap;
          padding: 0.2rem 0;
          span {
            width: 46%;
            margin: 2%;
            background-color: #ebebf3;
            color: #645f76;
            line-height: 0.6rem;
          }
        }
      }
    }
  }
  .city3 {
    padding-bottom: 0.5rem;
    .swiper-tab {
      display: flex;
      border-bottom: 1px solid #e2e2e2;
      li {
        line-height: 1.1rem;
        text-align: center;
        font-size: 0.32rem;
        position: relative;
        &:nth-child(1) {
          width: 22%;
        }
        &:nth-child(2) {
          width: 22%;
        }
        &:nth-child(3) {
          width: 26%;
        }
        &:nth-child(4) {
          width: 30%;
        }
      }
      .indexActive {
        i {
          width: 80%;
          height: 2px;
          display: block;
          background-color: #6b56e9;
          position: absolute;
          bottom: -1px;
          left: 10%;
        }
      }
    }
  }
  .city4 {
    background: url("../../assets/images/city11.jpg") no-repeat left center;
    height: 11.2rem;
    background-size: 100% auto;
    .title {
      color: #fff;
    }
  }
  .city5 {
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 0 0.2rem;
      margin-top: -0.3rem;
      li {
        width: 46%;
        margin: 2%;
        text-align: center;
        padding: 0.3rem;
        box-shadow: 0px 0.1rem 0.2rem 0px rgba(0, 0, 0, 0.08);
        img {
          width: 2rem;
        }
        span {
          display: block;
          font-size: 0.36rem;
          font-weight: 500;
          padding-bottom: 0.2rem;
        }
        p {
          font-size: 0.3rem;
          color: #888;
        }
      }
    }
  }
  .city6 {
    padding-top: 0.3rem;
    padding-bottom: 0;
    .swiper-container {
      border-top: 1px solid #eee;
      padding-bottom: 0.6rem;
      padding-top: 0.3rem;
      .list6 {
        .t1 {
          text-align: center;
          font-size: 0.36rem;
          color: #5d37e7;
          line-height: 1rem;
          display: block;
          position: relative;
          b {
            width: 0.8rem;
            height: 2px;
            background-color: #5d37e7;
            display: block;
            position: absolute;
            left: 50%;
            margin-left: -0.4rem;
            bottom: 0.15rem;
          }
        }
        .t2 {
          height: 5.5rem;
          display: flex;
          align-items: center;
          ul {
            display: flex;
            flex-wrap: wrap;
            padding: 0 0.2rem;
            li {
              width: 46%;
              margin: 0 2%;
              margin-bottom: 0.3rem;
              background-color: #f2f3f7;
              height: 1.2rem;
              display: flex;
              align-items: center;
              padding-left: 0.4rem;
              overflow: hidden;
              img {
                width: 0.6rem;
                margin-right: 0.1rem;
              }
              span {
                font-size: 0.34rem;
                flex: 1;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .city7 {
    height: 8.85rem;
    background: url("../../assets/images/city40.jpg") no-repeat center center;
    background-size: 100% auto;
    margin-top: 0.5rem;
    text-align: center;
    padding-top: 4rem;
    margin-bottom: -1rem;
    h3 {
      font-size: 0.6rem;
      font-weight: 500;
      span {
        color: #5d37e7;
      }
    }
    h4 {
      font-size: 0.36rem;
      font-weight: 400;
      color: #666;
      padding: 0.3rem 0 0.5rem;
    }
    button {
      height: 0.95rem;
      width: 3.5rem;
      background-color: #f05f58;
      border-radius: 1rem;
      color: #fff;
      font-size: 0.36rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/cityoto.vue